import React, { useEffect } from 'react';
import cx from 'classnames';
import PlusBoxIcon from '../../../../assets/icons/PlusBoxIcon';
import {invoiceData, expenseData} from "../../../../@types"
interface ProgressProps {
  title: string;
  value: string;
  text: string;
  icon: React.ReactNode;
  totalNumber: number | null;
  valueIcon: React.ReactNode;
  data?: invoiceData | expenseData | any
}

const Progress: React.FC<ProgressProps> = ({ title, data, value, text, icon, totalNumber, valueIcon }) => {
  const options = { style: 'decimal' };

  const iconStyle = {
    color: '#0D8DBF',
  };
  return (
    <div className='lg:mt-[-0.4em] xl:mt-0 2xl:mt-0 '>
      <div className=" px-[14px] xl:flex-initial biglg:mt-[em] lg:mt-[em] xl:mt-0 2xl:mt-0 3xl:ml-0">
        <div className=" pt-[24px] flex items-center justify-between">
          <div className="  flex gap-[3px] items-center  ">
            {icon}
            <p className="text-[14px] md:text-[14px] xl:text-[16px] text-[#000000] font-normal leading-5 " >{title}</p>
          </div>

          <div className="flex items-center gap-[6px]">
            <p className="text-[11px] md:text-[14px] lg:text-[12px] font-medium ">{value}</p>
            <span className="icon" style={iconStyle}>
                {valueIcon}
              </span>
          </div>
        </div>
        <p className="text-[12px] biglg:text-[13px] lg:text-[12px]  xl:text-[14px] 2xl:text-[15px] text-[#828282] mt-[21px]">
          {text}: <b className="text-black ">{totalNumber}</b>
        </p>
        <div className="mt-[2px] flex">
          <div className="w-[70%] h-[7px] bg-[#0D8DBF] rounded-l-[4px]"></div>
          <div className="w-[30%] h-[7px] bg-[#D82020] rounded-r-[4px]"></div>
        </div>

       {title === "Invoices" ? <div className="text-[14px] md:text-[20px] gap-[6px]  flex  flex-grow-0 md:w-auto xl:text-[5px] xl:mx-0 justify-between text-center biglg:gap-[6px] lg:gap-[16px] xl:gap-[6px] 2xl:gap-[6px]">
          <Card title="Total Value" bgColorClass="bg-orange-200" value={`N ${data?.totalInvoiceValue.toLocaleString("en-Us", options) }`} />
          <Card title="Paid" bgColorClass="bg-teal-100" value={`N ${data?.totalPaidInvoiceValue.toLocaleString("en-Us", options)}`} />
          <Card title="Unpaid" bgColorClass="bg-red-100" value={`N ${data?.totalUnPaidInvoiceValue.toLocaleString("en-Us", options)}`} />
        </div> :
         <div className=" text-[14px] md:text-[20px] gap-[6px] flex flex-grow-0 justify-between biglg:gap-[6px] lg:gap-[6px]  xl:gap-[6px] 2xl:gap-[6px] text-center">
          <Card title="Actual Expense"   bgColorClass="bg-orange-200" value={`N ${data?.totalExpenseValue.toLocaleString("en-Us", options)}`}  />
          <Card title="Billable Expense" valuePosition={{marginRight: "30px"}} bgColorClass="bg-teal-100" value={`N ${data?.totalBillableExpenseValue.toLocaleString("en-Us", options)}`} />
          <Card title="Non-Billable"  bgColorClass="bg-red-100" value={`N ${data?.totalNonBillableExpenseValue.toLocaleString("en-Us", options)}`} />
        </div>} 
      </div>
    </div>
  );
};

export { Progress };

interface InfoCardProps {
  title: string;
  value: string;
  bgColorClass: string;
  valuePosition?: {marginRight: string};
}

const Card: React.FC<InfoCardProps> = ({ title, value, bgColorClass, valuePosition }) => {
  const bgClassName = (bgColorClass: string) => {
    return cx('lg:w-[184px] xl:w-[210px] 2xl:w-[240px] lg:h-[79px] w-[100px] md:w-[240px] h-[65px] rounded flex items-center pl-[] mt-[20px] font-semibold ', {
      [bgColorClass]: true,
    });
  };

  return (
    <div className={bgClassName(bgColorClass || 'bg-[#044E97]')}>
      <div className="flex flex-col w-full h-[89px] justify-center items-center gap-[2px]">
        <p className="font-semibold text-[#828282] items-center xl:text-[15px] 2xl:text-[10px]  2xl:pl-[20px] text-[9px] xl:leading-4  2xl:leading-6 tracking-wide" style={{ whiteSpace: 'nowrap' }}>{title}</p>
        <p className={'py-[2px] font-semibold lg:text-[12px] biglg:text-[14px] xl:text-[15px] value 2xl:text-xl 2xl:text-[10px] '} style={valuePosition}>{value}</p>
      </div>
    </div>
  );
};

export { Card };